<span class="material-symbols-outlined text-gray-800" [style.fontSize.px]="height">{{ name }}</span>
